import Yup from '../../../yup-extended';

export default Yup.object({
  name: Yup.string().required('Please enter a name'),
  emailAddress: Yup.array().emailList(),
  themeId: Yup.number().nullable().required('Please select a theme'),
  visitorTypes: Yup.array().of(
    Yup.object().shape({
      visitorTypeId: Yup.number()
        .nullable()
        .required('Please select a visitor type'),
      questionnaireEmailAddress: Yup.array().emailList(),
      supplementaryQuestionnaireEmailAddress: Yup.array().emailList(),
    }),
  ),
});
